import { UntitledIcon } from '@faceup/icons'
import { ulLoading02 } from '@faceup/icons/ulLoading02'
import { FormItem, useAwait } from '@faceup/ui'
import {
  DatePicker as UiDatePicker,
  type DatePickerProps as UiDatePickerProps,
} from '@faceup/ui-base'
import moment from 'moment-timezone'
import type { FieldValues, UseControllerProps } from 'react-hook-form'
import { useCustomController } from '../hooks'
import type { FormItemWrapperProps } from '../typings'

export type DatePickerProps<T extends FieldValues> = UseControllerProps<T> &
  Omit<UiDatePickerProps & FormItemWrapperProps, 'value' | 'defaultValue' | 'placeholder'> & {
    placeholder?: string | Promise<string>
    loading?: boolean
  }

export const DatePicker = <T extends FieldValues>(props: DatePickerProps<T>) => {
  const {
    formItemProps,
    inputProps: { onChange: fieldOnChange, value, placeholder, loading, ...inputProps },
  } = useCustomController(props)
  const awaitedPlaceholder = useAwait(placeholder)

  return (
    <FormItem {...formItemProps}>
      <UiDatePicker
        {...inputProps}
        placeholder={awaitedPlaceholder}
        onChange={(date, dateString) => {
          fieldOnChange(date)
          props.onChange?.(date, dateString)
        }}
        value={value ? moment(value) : ''}
        prefix={loading ? <UntitledIcon icon={ulLoading02} isSpinning /> : inputProps.prefix}
      />
    </FormItem>
  )
}
